<script setup lang="ts">
    // TODO Migera till användning av KAutocomplete när det är på plats

    import { getConfig, klinikenApi } from "@/api";
    import { openDialog } from "@/utils";
    import debounce from "lodash/debounce";
    import { onBeforeMount, ref, watch } from "vue";

    withDefaults(defineProps<{ name?: string }>(), { name: "huvudoperationskod" });

    const huvudoperationskoder = ref<
        Array<{
            label: string;
            value: number;
        }>
    >([]);
    const chosenHuvudoperationskod = ref<number | null>(null);

    const fetchHuvudoperationskoder = async (newSearchValue = "") => {
        const params: {
            q?: string;
        } = {};

        /*
            Gör en inte en ny sökning om sökningen är tom och ett värde är satt, för att behålla displayname för
            att behålla display name för valt värde
         */
        if (newSearchValue === "" && chosenHuvudoperationskod.value) {
            return;
        }

        if (newSearchValue !== "") {
            params.q = newSearchValue;
        }

        try {
            const response = await klinikenApi.get<{
                results: Array<{
                    id: number;
                    code: string;
                    displayName: string;
                }>;
            }>(
                "/operation/kodverk/operationskoder/",
                getConfig({
                    params,
                })
            );

            huvudoperationskoder.value = response.data.results.map(({ id, code, displayName }) => {
                return {
                    value: id,
                    label: `${code} ${displayName}`,
                };
            });
        } catch (error) {
            openDialog("Kunde inte hämta huvudoperationskoder.", "warning");
        }
    };

    /**
     * Anropas av autocomplete
     */
    const debouncedFetch = debounce(fetchHuvudoperationskoder, 350);

    /**
     * Gör en ny sökning om autocomplete resettas
     */
    watch(chosenHuvudoperationskod, async (newValue) => {
        if (!newValue) {
            await fetchHuvudoperationskoder();
        }
    });

    onBeforeMount(async () => {
        await fetchHuvudoperationskoder();
    });
</script>

<template>
    <FormulateInput
        v-model="chosenHuvudoperationskod"
        :name="name"
        label="Huvudoperationskod"
        type="vueselect"
        :options="huvudoperationskoder"
        @search="debouncedFetch"
    />
</template>
